import { InputField } from 'components'
import { useFormikContext, FieldArray } from 'formik'
import {
  Button,
  ListGroupItem
} from 'reactstrap'
import PropTypes from 'prop-types'
import { InputGroupField } from 'components/molecules'
import { useState, useEffect } from 'react'
import UrlTypeButton from 'domains/cms-story-group/form/url-type-button'

const propTypes = {
  name          : PropTypes.string,
  selectedStory : PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object
  ]),
  onClickOpenDrawer : PropTypes.func,
  onRemoveImage     : PropTypes.func,
  onRemoveStory     : PropTypes.func
}

const defaultProps = {
  name              : '',
  selectedStory     : {},
  onClickOpenDrawer : () => { },
  onRemoveImage     : () => { },
  onRemoveStory     : () => { }
}

const defaultCmsStoryAttr = {
  cms_media_id  : '',
  button_text   : '',
  link_url_path : ''
}
/**
 * Renders inputs for the array of codes
 * - `Cms::StoryGroup` has_many `Cms::Story`
 */
const CmsStoryFieldArray = ({
  name,
  selectedStory,
  onClickOpenDrawer,
  onRemoveImage,
  onRemoveStory
}) => {

  const formik = useFormikContext()

  const [ externalUrls, setExternalUrls ] = useState([])


  useEffect(() => {
    formik.values.stories.forEach((story, index) => {
      // if internal url, it will start with '/' because it's still in https://www.tinkerlust.com domain
      // interal url ex: '/collections/shoes-disc-up-to-70' which will result 'https://www.tinkerlust.com//collections/shoes-disc-up-to-70'
      // external url ex: 'https://wa.me/628216387123'
      const isExternalUrl = story.link_url_path.charAt(0) !== '/'
      if (isExternalUrl) {
        setExternalUrls((oldValue) => ([ ...oldValue, index ]))
      }
    })
  }, [ formik.values.stories ])

  const isImageSelected = (index) => {
    if (selectedStory == undefined) return false
    if (selectedStory[ index ] == undefined) return false
    if (Object.keys(selectedStory[ index ]).length > 0) return true

    return true
  }

  const addCmsStory = (arrayHelpers) => {
    arrayHelpers.push(defaultCmsStoryAttr)
  }

  const removeCmsStory = (arrayHelpers, index) => {
    arrayHelpers.remove(index)
    onRemoveStory(index)
  }

  const handleClickInternalUrl = (index) => {
    const newExternalUrls = externalUrls.filter( (datum) => datum !== index )
    setExternalUrls(newExternalUrls)
  }

  const handleClickExternalUrl = (index) => {
    if (externalUrls.includes(index)) return

    setExternalUrls((oldValue) => ([ ...oldValue, index ]))
  }

  const addonType = (index) => (
    externalUrls.includes(index)? '' : 'prepend'
  )

  return (
    <FieldArray name={ name }>
      {
        (arrayHelpers) => (
          <>
            {
              // ! <tr> key prop must use a value that does not change
              // - prevents input from losing focus onChange
              formik.values.stories.map((story, index) => (
                <ListGroupItem
                  className='d-flex'
                  key={ `cms-story-attr-row-${index}` }
                >
                  <div className='d-flex flex-column' style={{ width: '200px' }}>
                    {
                      isImageSelected(index)
                        ? (
                          <>
                            <img src={ selectedStory[index].url } />
                            <Button
                              className='mr-0'
                              size='sm'
                              color='warning'
                              onClick={ () => onRemoveImage(index) }
                            >
                              <i className="fas fa-trash" />
                            </Button>
                            <div className="small">{ selectedStory[index].file_name }</div>
                          </>
                        )
                        : (
                          <Button onClick={ () => onClickOpenDrawer('story', index) } >
                            { 'Select Media' }
                          </Button>
                        )
                    }
                  </div>



                  <div className='p-3 w-100'>
                    <div className='float-right'>
                      <UrlTypeButton
                        index={ index }
                        onClickSelectUrlType={ handleClickInternalUrl }
                        buttonText={ 'Internal Url' }
                        disabled={ !externalUrls.includes(index) }
                      />

                      <UrlTypeButton
                        index={ index }
                        onClickSelectUrlType={ handleClickExternalUrl }
                        buttonText={ 'External Url' }
                        disabled={ externalUrls.includes(index) }
                      />
                    </div>

                    <InputGroupField
                      name={ `${name}.${index}.link_url_path` }
                      label='Link Url'
                      inputGroupText='https://www.tinkerlust.com'
                      type='text'
                      addonType={ addonType(index) }
                    >
                      <Button
                        outline
                        tag={ 'a' }
                        target={ '_blank' }
                        href={ story.link_url_path }
                        size='sm'
                        className='float-right'
                        color='primary'
                      >
                        { 'Open the Url Link' }
                      </Button>
                    </InputGroupField>
                    <InputField
                      type={ 'text' }
                      label={ 'Button Text' }
                      name={ `${name}.${index}.button_text` }
                    />
                  </div>

                  <div className='p-3 ml-auto'>
                    <Button
                      outline
                      block
                      color={ 'danger' }
                      onClick={ () => removeCmsStory(arrayHelpers, index) }
                    >
                      <i className="fas fa-trash" />
                    </Button>
                  </div>
                </ListGroupItem>
              ))
            }
            {
              formik.values.stories.length === 0 && (
                <ListGroupItem>
                  <i className='fas fa-info-circle mr-2' />
                  <span>{ 'Story Group ini tidak memiliki Story' }</span>
                </ListGroupItem>
              )
            }
            <ListGroupItem>
              <Button
                outline
                block
                color={ 'primary' }
                onClick={ () => addCmsStory(arrayHelpers) }
              >
                { '+ Add Story' }
              </Button>
            </ListGroupItem>
          </>
        )
      }
    </FieldArray>
  )
}

CmsStoryFieldArray.propTypes    = propTypes
CmsStoryFieldArray.defaultProps = defaultProps

export default CmsStoryFieldArray
